module.exports = __webpack_public_path__ + "02_freckles.f25848d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer2/02_freckles.png
// module id = IULi
// module chunks = 0